import Grid from '@mui/material/Grid2';
import CobrandDropdown from './CobrandDropdown';
import RunButton from './RunButton';

const CounselingReportsHeader = ({
    paramCobrand,
    setParamCobrand,
    cobrandOptions,
    getReportData,
    inFlight,
}) => {
    const isLoading = inFlight || !cobrandOptions.length;

    return (
        <div className="my-4">
            <Grid container spacing={3} alignItems="center">
                <Grid size={{ xs: 8, md: 4, xl: 3 }}>
                    <CobrandDropdown
                        paramCobrand={paramCobrand}
                        setParamCobrand={setParamCobrand}
                        cobrandOptions={cobrandOptions}
                        isLoading={isLoading}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 2 }}>
                    <RunButton
                        onClick={getReportData}
                        isLoading={isLoading}
                        isDisabled={isLoading || paramCobrand?.length === 0}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default CounselingReportsHeader;
